import React from 'react';
import { FormattedMessage } from 'react-intl';

// @mui/material components
import { FormControlLabel, Switch } from '@mui/material';

/** The "open in a new tab" switch of a CTA link row. */
export default function OpenInNewTabSwitch({ checked, onChange }) {
    return (
        <FormControlLabel
            control={(
                <Switch
                    checked={checked}
                    onChange={(event) => onChange(event.target.checked)}
                    color="primary"
                    size="small"
                />
            )}
            label={<FormattedMessage id="category.form.ctaLinks.openInNewTab" />}
        />
    );
}
